/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import MenuButton from '../menuButton';
import s from './index.module.scss';

function Menu() {
  const firstLink = useRef(null);
  const dispatch = useDispatch();
  const menuOpened = useSelector((state) => state.global.menuOpened);
  const stateClass = menuOpened ? s.opened : '';
  const disableFromFocus = !menuOpened ? -1 : '';

  function onClickAction() {
    document.querySelector('#root').scrollTo(0, 0);

    dispatch({
      type: 'TOGGLE_MENU',
      payload: false,
    });
  }

  useEffect(() => {
    window.addEventListener('popstate', () => {
      onClickAction();
    });
  }, []);

  useEffect(() => {
    if (menuOpened) {
      firstLink.current.focus();
    }
  }, [menuOpened]);

  return (
    <nav className={`${s.menu} ${stateClass}`}>
      <div className={s.menuWrapper}><MenuButton disableFromFocus={disableFromFocus} /></div>
      <ul className={s.menuContent}>
        <li className={s.menuItem}><Link tabIndex={disableFromFocus} onClick={onClickAction} to="/" ref={firstLink}>Home</Link></li>
        <li className={s.menuItem}><Link tabIndex={disableFromFocus} onClick={() => window.location = 'mailto:welove@everydoggy.com'} to="/#">Contact Us</Link></li>
        {/* <li className={s.menuItem}><Link tabIndex={disableFromFocus} onClick={onClickAction} to="/faq">FAQ</Link></li> */}
        <li className={s.menuItem}><a tabIndex={disableFromFocus} href="https://app.everydoggy.com/policies/" target="_blank" rel="noreferrer">Privacy policy</a></li>
        <li className={s.menuItem}><a tabIndex={disableFromFocus} href="https://app.everydoggy.com/terms/" target="_blank" rel="noreferrer">Terms & Conditions</a></li>
      </ul>
      <div className={s.closeArea} onClick={onClickAction} />
    </nav>
  );
}

export default Menu;
